// extracted by mini-css-extract-plugin
export default {"markerIcon":"base-marker-badge-module__markerIcon--Dn4NC","marker":"base-marker-badge-module__marker--gkxSq"};